module.exports = __webpack_public_path__ + "static/media/Background3.58306881.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background3.png
// module id = 76
// module chunks = 0